/*
 |--------------------------------------------------------------------------
 |  The entry point for the css.
 |--------------------------------------------------------------------------
 */

@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

@import 'base/components.pcss';
@import 'base/global.pcss';
@import 'base/modern-css-reset.pcss';
@import 'base/sections.pcss';
@import 'base/text.pcss';
